@use "diy_base.module.scss";
@use "foundation/colors";
@use "foundation/responsive";

.chat-shell {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  width: 100%;
}

.diy-composer {
  display: flex;
  align-items: center;
  flex-direction: column;

  margin-top: diy_base.$diy-composer-margin;

  @include responsive.phone {
    margin-top: diy_base.$diy-composer-margin-phone;
    margin-bottom: diy_base.$diy-composer-margin-phone;
  }

  &.filter-code-view {
    margin-top: 0 !important;
  }

  &.has-bottom-bar {
    padding-bottom: 5em;
    @include responsive.phone {
      padding-bottom: 7em;
    }
  }

  ul.creation-mode-switcher {
    width: diy_base.$box-width;
    margin-bottom: 2em;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    @include responsive.phone {
      width: diy_base.$box-width-phone;
    }

    li {
      font-weight: 700;
      line-height: 1.375em;
      cursor: pointer;
      box-sizing: border-box;
      border-bottom: 4px solid;
      border-color: transparent;
    }

    li.selected {
      border-color: inherit;
    }

    li:last-child {
      margin-left: 64px;
    }
  }

  &.chat-style {
    flex: 1;
    min-height: 0;

    ul.creation-mode-switcher {
      width: 100%;
      align-items: stretch;
      gap: 64px;
      margin-bottom: 5em;
      border-bottom: 2px solid colors.$input-border-color;

      @include responsive.phone {
        width: 100%;
      }

      li {
        position: relative;
        line-height: 1.3;
        border-bottom: none;
      }

      li > a {
        display: block;
        padding: 16px 12px;
        cursor: pointer;
      }

      li.selected::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        height: 4px;
        background-color: colors.$primary-eerie-black;
      }

      li:last-child {
        margin-left: 0;
      }
    }

    // Display is set inline (chat-side flex, classic-side block) in index.tsx.
    section.mode-containers {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
    }
  }

  section.mode-containers {
    width: 100%;
  }
}

.chat-shell .diy-composer.chat-style {
  margin-top: 0;

  ul.creation-mode-switcher {
    margin-bottom: 0;
  }
}

.tooltip {
  margin-top: -2em; /* 36px */
  margin-bottom: 2.56em; /* 46px */
}
